import React from 'react'

const Navbar = () => {
  return (
    <nav className="navbar bg-secondary navbar-expand-lg navbar-light px-4 px-lg-5 py-3 py-lg-0">
                <a href="" className="navbar-brand p-0">
                    <h1 className="text-primary"><img src="img/logo.png" alt="Logo" />PHG Africa</h1>
                    
                </a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                    <span className="fa fa-bars"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarCollapse">
                    {/* <!-- <div className="navbar-nav ms-auto py-0">
                        <a href="index.html" className="nav-item nav-link active">Home</a>
                        <a href="about.html" className="nav-item nav-link">About</a>
                        <a href="service.html" className="nav-item nav-link">Service</a>
                        <a href="blog.html" className="nav-item nav-link">Blog</a>
                        <div className="nav-item dropdown">
                            <a href="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown">Pages</a>
                            <div className="dropdown-menu m-0">
                                <a href="feature.html" className="dropdown-item">Our Feature</a>
                                <a href="product.html" className="dropdown-item">Our Product</a>
                                <a href="team.html" className="dropdown-item">Our Team</a>
                                <a href="testimonial.html" className="dropdown-item">Testimonial</a>
                                <a href="404.html" className="dropdown-item">404 Page</a>
                            </div>
                        </div>
                        <a href="contact.html" className="nav-item nav-link">Contact</a>
                    </div> --> */}

                    <div className="navbar-nav ms-auto py-0">
                        <a href="#" className="nav-item nav-link active">Home</a>
                        <a href="#" className="nav-item nav-link">About</a>
                        <a href="#" className="nav-item nav-link">Service</a>
                        <a href="#" className="nav-item nav-link">Blog</a>
                        <div className="nav-item dropdown">
                            <a href="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown">Pages</a>
                            <div className="dropdown-menu m-0">
                                <a href="#" className="dropdown-item">Our Feature</a>
                                <a href="#" className="dropdown-item">Our Product</a>
                                <a href="#" className="dropdown-item">Our Team</a>
                                <a href="#" className="dropdown-item">Testimonial</a>
                                <a href="#" className="dropdown-item">404 Page</a>
                            </div>
                        </div>
                        <a href="#" className="nav-item nav-link">Contact</a>
                    </div>
                    <div className="d-none d-xl-flex me-3">
                        <div className="d-flex flex-column pe-3 border-end border-primary">
                            <span className="text-body">Speak to Us Now</span>
                            <a href="tel:+4733378901"><span className="text-primary">Admin: +233 242 029 161</span></a>
                        </div>
                    </div>
                    <button className="btn btn-primary btn-md-square d-flex flex-shrink-0 mb-3 mb-lg-0 rounded-circle me-3" data-bs-toggle="modal" data-bs-target="#searchModal"><i className="fas fa-search"></i></button>
                    {/* <!-- <a href="" className="btn btn-primary rounded-pill d-inline-flex flex-shrink-0 py-2 px-4">Order Now</a> --> */}
                </div>
            </nav>
  )
}

export default Navbar